import React, { useContext, useState } from "react";
import { groupContext } from "../index.js";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import Description from "../../../components/description/description.js";
import { PriceListInTab } from "../priceListInTab/priceListInTab.js";
import "./nav-left.css";
export default function NavbarLeft() {
    var _a, _b, _c;
    const groupData = useContext(groupContext);
    const [contactOpen, setContactOpen] = useState(false);
    const [priceListOpen, setPriceListOpen] = useState(false);
    return (React.createElement("div", { className: "nav-left-container" },
        ((_a = groupData === null || groupData === void 0 ? void 0 : groupData.appearance) === null || _a === void 0 ? void 0 : _a.design) !== "smthl-material" && (React.createElement(React.Fragment, null,
            React.createElement(Button, { text: "", value: "contact", onClick: () => {
                    setContactOpen(true);
                }, classNames: "client-nav-button", version: "alternative" },
                React.createElement("span", null, "Kontakt"),
                React.createElement("img", { style: {}, about: "https://uxwing.com/ - super website", src: "../../assets/icons/contact-us.svg", height: "25" })),
            ((_b = groupData === null || groupData === void 0 ? void 0 : groupData.appearance) === null || _b === void 0 ? void 0 : _b.priceListType) == "in_tab" && (React.createElement(Button, { text: "Cennik", value: "price_list", onClick: () => setPriceListOpen(true), version: "alternative" })))),
        ((_c = groupData === null || groupData === void 0 ? void 0 : groupData.appearance) === null || _c === void 0 ? void 0 : _c.design) === "smthl-material" && (React.createElement(React.Fragment, null,
            innerWidth > 480 && "Grupa: ",
            groupData.groupName)),
        contactOpen && (React.createElement(Description, { value: groupData.contactData, onLeave: () => {
                setContactOpen(false);
            } })),
        priceListOpen && (React.createElement(PriceListInTab, { categories: groupData.categories, onExit: () => setPriceListOpen(false) }))));
}
